export default "__VITE_ASSET__4bb69ab0__"